import { atBqnGiven } from "common/api";

export const parseRowGivenHeader = (headers) => (row) =>
  Object.fromEntries(
    row.split(/\s+/).map((value, index) => [headers[index], value])
  );

const rowAsInterface = parseRowGivenHeader(["name", "id"]);

export const parseInterfacesList = (input) => {
  const [_head, ...lines] = input.trim().split("\n");
  return lines.map(rowAsInterface);
};

// The interfaces of the BQN given, and those of the whole cluster when there
// is no BQN to ask for: the caller resolved the BQN selected in the header
// already, with bqnIdTarget, so there is no mode to take into account here.
export const loadAndParseInterfaces = (bqnId) =>
  ifCl
    .run(atBqnGiven("show interface pkteng interface-id", bqnId))
    .then(parseInterfacesList);

export default loadAndParseInterfaces;
